angular.module('app').factory('StateService', function () {
    let tester = { Id: -1, Name: 'Not Selected' };
    let sim = { Id: -1, Name: 'Not Selected' };
    let suite = { Id: -1, Name: 'Not Selected' };
    let test = { Id: -1, Name: 'Not Selected' };
    function reset() {
        this.selectedTester = { Id: -1, Name: 'Not Selected' };
        this.selectedSim = { Id: -1, Name: 'Not Selected' };
        this.selectedSuite = { Id: -1, Name: 'Not Selected' };
        this.selectedTest = { Id: -1, Name: 'Not Selected' };
    }
    let fac = {
        selectedTester: tester,
        selectedSim: sim,
        selectedSuite: suite,
        selectedTest: test,
        reset: reset
    };
    return fac;
});
